exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-crm-tsx": () => import("./../../../src/pages/crm.tsx" /* webpackChunkName: "component---src-pages-crm-tsx" */),
  "component---src-pages-index-bak-tsx": () => import("./../../../src/pages/index_bak.tsx" /* webpackChunkName: "component---src-pages-index-bak-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-jobs-job-job-id-tsx": () => import("./../../../src/pages/jobs/{job.jobId}.tsx" /* webpackChunkName: "component---src-pages-jobs-job-job-id-tsx" */)
}

